/**
 * Catalogue des événements webhook v1 (miroir de PARTNER_EVENT_TYPES côté
 * backend, `src/services/partner-webhook.service.js`).
 */

export const EVENT_TYPES = [
  'delivery.request.accepted',
  'delivery.request.failed',
  'delivery.request.expired',
  'delivery.request.canceled',
  'delivery.status.assigned',
  'delivery.status.picked_up',
  'delivery.status.delivered',
  'delivery.status.canceled',
  'delivery.status.incident',
  'payment.succeeded',
  'payment.failed',
]

export const EVENT_DESCRIPTIONS: Record<string, string> = {
  'delivery.request.accepted':
    "Un livreur a accepté la demande : la livraison existe désormais (champ deliveryId).",
  'delivery.request.failed':
    "Aucun livreur n'a pu être trouvé pour cette demande.",
  'delivery.request.expired': "La demande a expiré sans être acceptée.",
  'delivery.request.canceled': "La demande a été annulée avant acceptation.",
  'delivery.status.assigned': 'La livraison a été assignée à un livreur.',
  'delivery.status.picked_up': 'Le colis a été récupéré au point de ramassage.',
  'delivery.status.delivered': 'Le colis a été remis au destinataire.',
  'delivery.status.canceled': 'La livraison a été annulée.',
  'delivery.status.incident': 'Un incident a été déclaré sur la livraison.',
  'payment.succeeded': 'Le paiement a été confirmé.',
  'payment.failed': 'Le paiement a échoué.',
}
